import { fetch, Method, getPaging } from 'core/api/fetch';
import { parsePaymentToModel, parsePaymentToObject } from 'core/api/parser/payment';

const PaymentRoutes = {
    get: (id) => `/api/v1.1.0/admin/payment/${id}`,
    getList: (options) => `/api/v1.1.0/admin/payment?email=${options.emailSearch}&bookingCode=${options.bookingCodeSearch}&type=${options.type ?? 'payments'}&${getPaging(options)}`,
    // getExperienceList: (id,options) => `/api/v1.1.0/admin/contract/${id}/experience?${getPaging(options)}`,
    add: '/api/v1.1.0/admin/payment',
    update: (id) => `/api/v1.1.0/admin/payment/${id}`,
    // updateExperiences: (id) => `/api/v1.1.0/admin/contract/${id}`,
    // deleteExperiences: (id, expId) => `/api/v1.1.0/admin/contract/${id}/experience/${expId}`,
    uploadImage: (id) => `/api/v1.1.0/admin/payment/${id}/image`,
    // getQRCode: (id) => `/api/v1.1.0/admin/contract/${id}/qr`,
};

export const PaymentService = {
    get: async (id) => {
        try {
            const { data } = await fetch(PaymentRoutes.get(id), {
                method: Method.GET,
                authenticated: true,
            });
            return !data || !data.length ? {} : parsePaymentToObject(data[0]);
        } catch (err) {
            throw new Error(err);
        }
    },
    getList: async (options) => {
        try {
            const { data } = await fetch(PaymentRoutes.getList(options), {
                method: Method.GET,
                authenticated: true,
            });
            // return !data || !data.length ? [] : data.map(parseContractToModel);
            return !data ? { payments: [], total: 0 } : { total: data.total, payments: data.payments.map(parsePaymentToModel) };
        } catch (err) {
            throw new Error(err);
        }
    },

    // getExperienceList: async (id,options) => {
    //     try {
    //         const { data } = await fetch(PaymentRoutes.getExperienceList(id,options), {
    //             method: Method.GET,
    //             authenticated: true
    //         });
    //         // return !data || !data.length ? [] : data.map(parseContractToModel);
    //         return !data ? {experiences:[],total:0} : {total: data.total, experiences: data.experiences};
    //     } catch (err) {
    //         throw new Error(err);
    //     }
    // },

    add: async (info) => {
        try {
            const { data } = await fetch(PaymentRoutes.add, {
                method: Method.POST,
                authenticated: true,
                data: info,
            });
            return !data || !data.status ? false : data; // parseContractToObject(data[0]);
        } catch (err) {
            throw new Error(err);
        }
    },

    update: async (info) => {
        try {
            const { data } = await fetch(PaymentRoutes.update(info.id), {
                method: Method.PATCH,
                authenticated: true,
                data: info,
            });
            return !data || !data.status ? false : data;
        } catch (err) {
            throw new Error(err);
        }
    },

    // updateExperiences: async (id, info) => {
    //     try {
    //         const { data } = await fetch(PaymentRoutes.updateExperiences(id), {
    //             method: Method.POST,
    //             authenticated: true,
    //             data: info,
    //         });
    //         return Array.isArray(data) ? data[0] : false;
    //     } catch (err) {
    //         throw new Error(err);
    //     }
    // },

    // deleteExperiences: async (id, expId) => {
    //     try {
    //         const { data } = await fetch(PaymentRoutes.deleteExperiences(id, expId), {
    //             method: Method.DELETE,
    //             authenticated: true,
    //         });
    //         return Array.isArray(data) ? data[0] : false;
    //     } catch (err) {
    //         throw new Error(err);
    //     }
    // },

    uploadPaymentPicture: async (id, image) => {
        try {
            const formData = new FormData();
            image = image.type && image.type !== '' ? image : image.slice(0, image.size, 'image/png');
            formData.append('images', image, image.name ?? `payment_${id}.png`);
            await fetch(PaymentRoutes.uploadImage(id), {
                method: Method.POST,
                authenticated: true,
                data: formData,
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
        } catch (err) {
            throw new Error(err);
        }
    },

    // getQRCode: async (id) => {
    //     try {
    //         const { data } = await fetch(PaymentRoutes.getQRCode(id), {
    //             method: Method.GET,
    //             authenticated: true
    //         });
    //         return Array.isArray(data) ? data[0] : false;
    //     } catch (err) {
    //         throw new Error(err);
    //     }
    // },
};
